export const locations = [
  '北京',
  '上海',
  '广州',
  '深圳',
  '香港',
  '成都',
  '杭州',
  '重庆',
  '武汉',
  '苏州',
  '西安',
  '天津',
  '南京',
  '郑州',
  '长沙',
  '沈阳',
  '青岛',
  '宁波',
  '东莞',
  '无锡',
  '昆明',
  '大连',
  '厦门',
  '合肥',
  '佛山',
  '福州',
  '哈尔滨',
  '济南',
  '温州',
  '长春',
  '石家庄',
  '其他',
]

const locationOptions = (function() {
  return locations.map(val => ({
    value: val,
    label: val,
  }))
})()

export const projectStatus = ['进展中', '已暂停', '已成功', '已失败']

export const education = ['中专', '大专', '本科', '硕士', '博士', '博士后']

export const educationTags = [
  '博士及以上',
  '硕士',
  '本科',
  '常青藤',
  '清北交复',
  '985',
  '211',
  '常春藤',
  '海外背景',
  'QS100',
  'TIMES100',
  '理工科',
  '财务',
  '法务',
  '金融',
  '医药医疗',
  '微电子',
  '计算机',
  '中金line',
  '中信line',
  '建投line',
  '广发学历',
  '前海开源line',
]

export const languageTags = [
  '英文-1-母语水平',
  '英文-2-工作语言',
  '英文-3-可顺利读写，口语较弱',
  '粤语',
  '日语',
  '法语',
  '小语种',
]

export const professionalRank = [
  { label: 'AN', value: 'AN' },
  { label: 'Asso', value: 'Asso' },
  { label: 'SA', value: 'SA' },
  { label: 'VP', value: 'VP' },
  { label: 'SVP', value: 'SVP' },
  { label: 'AD', value: 'AD' },
  { label: 'D', value: 'D' },
  { label: 'ED', value: 'ED' },
  { label: 'MD', value: 'MD' },
]
export const manageRank = [
  { label: '公司总经理', value: '公司总经理' },
  { label: '公司副总', value: '公司副总' },
  { label: '公司总助', value: '公司总助' },
  { label: '部门总', value: '部门总' },
  { label: '部门副总', value: '部门副总' },
  { label: '部门总助', value: '部门总助' },
  { label: '总监', value: '总监' },
  { label: '副总监', value: '副总监' },
  { label: '经理', value: '经理' },
  { label: '主管', value: '主管' },
  { label: '专员', value: '专员' },
]

export const professionalLevel = [
  { label: '1、高管', value: '1' },
  { label: '2、部门总', value: '2' },
  { label: '3、部门副总-总助-团队长', value: '3' },
  { label: '4、部门核心骨干', value: '4' },
  { label: '5、新人（三年以下）', value: '5' },
]

export const 业绩 = ['aaa', 'aa', 'a', 'b', 'c', 'd']

export const projectEditItems = [
  {
    label: '基本信息',
    show: true,
    children: [
      { label: '公司*', key: '客户公司', remote: 'companies', type: 'complete', options: [], val: '', admin: true },
      { label: '部门', remote: 'departments', type: 'complete', options: [], val: '' },
      { label: '项目名称*', key: '项目名称', val: '' },
      { label: '客户开发*', key: '客户开发', multiple: true, filterable: true, remote: 'users', options: [], val: [] },
      { label: '项目对接*', key: '项目对接', multiple: true, filterable: true, remote: 'users', options: [], val: [] },
      { label: '项目经理', multiple: true, filterable: true, remote: 'users', options: [], val: [] },
      { label: '项目成员', multiple: true, filterable: true, remote: 'users', options: [], val: [] },
      { label: '目标行业', multiple: true, filterable: true, options: app.industries || [], val: [] },
      {
        label: '地域*',
        key: '地域',
        allowCreate: true,
        multiple: true,
        filterable: true,
        options: locationOptions,
        val: [],
      },
      { label: '招聘数量', val: '' },
      { label: '项目状态', options: projectStatus, val: '进展中' },
      { label: '开始日期', type: 'date', key: 'startTime', val: Date.now() },
      { label: '保证期', key: 'guaranteeTime', type: 'date', val: '' },
      { label: '预计第一批人推荐时间', key: 'indroduceTime', type: 'date', val: '' },
      { label: '优先级', type: 'rate', val: 1 },
    ],
  },
  {
    label: '岗位要求',
    show: true,
    children: [
      { label: '职能模块*', key: '职能模块', type: 'complete', options: [], val: '' },
      { label: '平台*', key: '平台', multiple: true, options: ['A', 'B', 'C'], val: [] },
      { label: '业绩*', key: '业绩', multiple: true, options: 业绩, val: [] },
      { label: '细分职能', multiple: true, options: [], val: [] },
      { label: '职级*', key: '职级', multiple: true, options: professionalLevel, val: [] },
      { label: '管理职级', val: '' },
      { label: '专业职级', type: 'complete', options: professionalRank, val: '' },
      { label: '擅长方向', multiple: true, options: [], val: [] },
      { label: '学历', options: education, val: '' },
      { label: '学历标签', multiple: true, options: educationTags, val: [] },
      { label: '语言能力', multiple: true, options: languageTags, val: [] },
      { label: '年龄要求', type: 'range', append: '年', val: ['', ''] },
      { label: '工作年限', type: 'range', append: '年', val: ['', ''] },
      { label: '月薪范围', type: 'range', append: '万', val: ['', ''] },
      { label: '年薪范围', type: 'range', append: '万', val: ['', ''] },
      {
        label: '性别',
        options: [{ label: '男', value: '男' }, { label: '女', value: '女' }, { label: '不限', value: '不限' }],
        val: '',
      },
      { label: '新增', type: 'checkBox', val: false },
      { label: '替代', type: 'checkBox', val: false },
      { label: '独家', type: 'checkBox', val: false },
      { label: '保密', type: 'checkBox', val: false },
    ],
  },
  { label: '岗位要求', type: 'textarea', val: '', show: true },
  { label: '岗位职责', type: 'textarea', val: '', show: true },
  { label: '寻访方向', show: true, type: 'textarea', val: '' },
  {
    label: '职位亮点及优势',
    show: true,
    children: [
      { label: '公司亮点及优势', type: 'textarea', val: '' },
      { label: '项目亮点及优势', type: 'textarea', val: '' },
    ],
  },
  { label: '薪资架构', show: true, type: 'textarea', val: '' },
  { label: '职位话述', key: '项目话术', show: true, val: '', type: 'textarea' },
  { label: '目标人选画像', key: 'keyWords', show: true, val: '', type: 'textarea' },
  { label: '部门详情', show: true, val: '', type: 'textarea' },
  { label: '领导介绍', show: true, key: '领导', val: { name: '', describe: '' } },
  { label: '其他', show: true, val: '', type: 'textarea' },
]

export const sortKeyFormat = {
  预计推荐时间: 'indroduceTime',
  开始时间: 'startTime',
  进展天数: 'startTime',
}

export const projectInfoItems = [
  {
    label: '基本信息',
    show: true,
    group: [
      {
        label: '目标行业',
        val: undefined,
      },
      {
        label: '保证期',
        key: 'guaranteeTime',
        type: 'date',
        val: undefined,
      },
      {
        label: '预计第一批人推荐时间',
        key: 'indroduceTime',
        type: 'date',
        val: undefined,
      },
    ],
  },
  {
    label: '岗位要求',
    show: true,
    group: [
      {
        label: '职能模块',
        key: '职能模块',
        val: undefined,
      },
      {
        label: '平台',
        val: undefined,
      },
      {
        label: '业绩',
        val: undefined,
      },
      {
        label: '细分职能',
        val: undefined,
      },
      {
        label: '职级',
        val: undefined,
      },
      {
        label: '管理职级',
        val: undefined,
      },
      {
        label: '专业职级',
        val: undefined,
      },
      {
        label: '擅长方向',
        val: undefined,
      },
      {
        label: '学历',
        val: undefined,
      },
      {
        label: '学历标签',
        val: undefined,
      },
      {
        label: '语言能力',
        val: undefined,
      },
      {
        label: '年龄要求',
        type: 'range',
        suffix: '年',
        val: undefined,
      },
      {
        label: '工作年限',
        type: 'range',
        suffix: '年',
        val: undefined,
      },
      {
        label: '月薪范围',
        type: 'range',
        suffix: '万',
        val: undefined,
      },
      {
        label: '年薪范围',
        type: 'range',
        suffix: '万',
        val: undefined,
      },
      {
        label: '性别',
        val: '不限',
      },
      {
        label: '新增',
        type: 'boolean',
        val: false,
      },
      {
        label: '替代',
        type: 'boolean',
        val: false,
      },
      {
        label: '独家',
        type: 'boolean',
        val: false,
      },
      {
        label: '保密',
        type: 'boolean',
        val: false,
      },
    ],
  },
  {
    label: '岗位要求',
    val: '',
    show: true,
  },
  {
    label: '岗位职责',
    val: '',
    show: true,
  },
  {
    label: '寻访方向',
    show: true,
    val: '',
  },
  {
    label: '职位亮点及优势',
    show: true,
    val: '',
  },
  {
    label: '薪资架构',
    show: true,
    val: '',
  },
  {
    label: '职位话述',
    key: '项目话术',
    show: true,
    val: '',
  },
  {
    label: '目标人选画像',
    key: 'keyWords',
    show: true,
    val: '',
  },
  {
    label: '部门情况',
    show: true,
    val: '',
  },
  {
    label: '领导介绍',
    key: '领导',
    show: true,
    val: '',
  },
  {
    label: '其他',
    show: true,
    val: '',
  },
]

export const tags = [
  { label: '语言能力', key: 'language', children: languageTags, checkList: [] },
  {
    label: '职业资格',
    key: 'vocation',
    children: [
      '保代',
      '准保',
      '保代A类',
      '保代B类',
      '保代C类',
      '基金从业资格',
      '证券从业资格',
      'CFA',
      'CPA',
      'FRM',
      '律师执业资格',
      '法律从业资格',
      'REITs基金经理从业资格',
      '期货从业资格',
      '银行从业资格',
      'CIA（审计师）',
      'ACCA（国际注册会计师）',
      'CMA（美国注册管理会计师）',
      'CISA（信息系统审计师）',
      'CTA（税务师）',
      'SOA（北美保险精算师）',
      'CAA（保险精算师）',
    ],
    checkList: [],
  },
  {
    label: '领导力',
    key: 'leadership',
    children: ['领导力强', '领导力弱', '逆商高', '逆商低', '强资源人脉'],
    checkList: [],
  },
  {
    label: '个人风格',
    key: 'personal',
    children: ['保守', '稳健', '开拓（追求卓越）', '激进（狼性文化）'],
    checkList: [],
  },
  {
    label: '专业因素',
    key: 'professional',
    children: [
      '专业能力强',
      '销售能力强',
      '研究功底扎实',
      '逻辑思维强',
      '思维散乱',
      '沟通能力强',
      '表达能力弱',
      '商业意识强',
      '执行力强',
    ],
    checkList: [],
  },
  {
    label: '心态、个性',
    key: 'mentality',
    children: [
      '心态积极正向',
      '消极负面',
      '战略思维、注重长远',
      '看重短期',
      '事业心强',
      '追求家庭工作平衡',
      '追求创新',
      '个性求稳',
      '积极进取',
      '结果导向',
    ],
    checkList: [],
  },
]

export const companyKeyWordLabel = {
  A: 'A-极度市场化',
  B: 'B-较市场化',
  C: 'C-大平台、合理激励',
  D: 'D-偏向国企风格，较保守',
  E: 'E-大国企、保守',
  F: 'F-团队作战，精英模式',
}

export const projectFileTypes = [
  '岗位JD',
  '岗位要求',
  '岗位职责',
  '寻访方向',
  '目标人选',
  '部门情况',
  '职位亮点及优势',
  '领导介绍',
  '薪资架构',
  '职位话术',
  '项目报告',
  '付款通知书',
  '项目小结',
  '其他',
]

export const fileTypes = [
  '岗位JD',
  '公司介绍',
  '直线背景',
  '部门架构',
  '职位话术',
  '部门介绍',
  '原始简历',
  '推荐报告',
  '背景调查',
  '薪资证明',
  '测评报告',
  '公司简介',
  '薪酬/职级/奖金机制',
  'SellingPoint',
  '公司O-Chart',
  '公司优劣势',
  '公司用人偏好',
  '业务特点/风格/资源来源',
  '特殊要求',
  '推荐模板',
  '其他',
]
